import { Col, Divider, Grid, Image, Row } from "antd";
import { Trans, useTranslation } from "react-i18next";
import Line from "../../../assets/images/footer/line.png";
import { P2, P3 } from "../../../components/NormalFonts";
import { envChangeType, handleClickCS } from "../../../plugins/utils";
import styles from "./styleModule";

const FooterComponent = () => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const renderPCFooter = () => {
    return (
      <>
        <div className={styles.footerColumn}>
          <div className={styles.colLeft}>
            <Image
              className={styles.logoImage}
              src={`/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/common/header_logo.png`}
              preview={false}
            />
            <div className={styles.socials}>
              <div className={styles.imageContainer} onClick={handleClickCS}>
                <Image src={Line} width={52} height={52} preview={false} />
              </div>
              <P3 style={{ textAlign: "left" }} color="rgba(64, 64, 64, 1)">
                <Trans i18nKey={"footer.line"} />
              </P3>
            </div>
          </div>
          <div className={styles.colRight}>
            <div className={styles.menuColumn}>
              <P2
                className={styles.title}
                weight="medium"
                color="var(--Neutral-light-10)"
              >
                {t("footer.terms.title")}
              </P2>
              <P2 className={styles.link} color="var(--Neutral-light-10)">
                {t("footer.about")}
              </P2>
              <P2 className={styles.link} color="var(--Neutral-light-10)">
                {t("footer.contact")}
              </P2>
              <P2 className={styles.link} color="var(--Neutral-light-10)">
                {t("footer.terms")}
              </P2>
              <P2 className={styles.link} color="var(--Neutral-light-10)">
                {t("footer.privacy")}
              </P2>
            </div>
            <div className={styles.menuColumn}>
              <P2
                className={styles.title}
                weight="medium"
                color="var(--Neutral-light-10)"
              >
                {t("footer.contact")}
              </P2>
              <P2 className={styles.link} color="var(--Neutral-light-10)">
                <a href={`mailto:abcdef1234@service.com`}>
                  abcdef1234@service.com
                </a>
              </P2>
            </div>
          </div>
        </div>
        <Divider
          style={{ borderBlockStart: "1px solid var(--Neutral-dark-60)" }}
        />
        <div className={styles.copyright}>
          <P3 color="var(--Neutral-light-10)">{t("footer.copyright")}</P3>
        </div>
      </>
    );
  };

  const renderMobileFooter = () => {
    return (
      <>
        <Image
          className={styles.logoImage}
          src={`/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/common/header_logo.png`}
          preview={false}
        />
        <div className={styles.socials}>
          <div className={styles.imageContainer} onClick={handleClickCS}>
            <Image src={Line} width={30} height={30} preview={false} />
          </div>
        </div>
        <div className={styles.termsContainer}>
          <P2 className={styles.link} color="var(--Neutral-light-10)">
            {t("footer.about")}
          </P2>
          <P2 className={styles.link} color="var(--Neutral-light-10)">
            {t("footer.contact")}
          </P2>
          <P2 className={styles.link} color="var(--Neutral-light-10)">
            {t("footer.terms")}
          </P2>
          <P2 className={styles.link} color="var(--Neutral-light-10)">
            {t("footer.privacy")}
          </P2>
        </div>
        <P2 className={styles.link} color="var(--Neutral-light-10)">
          <a href={`mailto:abcdef1234@service.com`}>
            {`${t("footer.cs")}: abcdef1234@service.com`}
          </a>
        </P2>
        <div className={styles.copyright}>
          <P3 color="var(--Neutral-light-10)">{t("footer.copyright")}</P3>
        </div>
      </>
    );
  };

  const getColSpan = () => {
    if (screens.lg) return 6;
    if (screens.md) return 12;
    return 24; // Default for xs or smaller
  };

  const handleClickLine = () => {
    window.open(process.env.REACT_APP_LINE_URL, "_blank");
  };

  const renderHiddenLinks = () => {
    return (
      <div style={{ display: "none" }}>
        <a
          href={`${envChangeType("REACT_APP_MAIN_URL")}/trainers`}
          title={t("header.menu.book")}
        >
          {t("header.menu.book")}
        </a>
        <a
          href={`${envChangeType("REACT_APP_MAIN_URL")}/guide`}
          title={t("header.menu.guide")}
        >
          {t("header.menu.guide")}
        </a>
        <a
          href={`${envChangeType("REACT_APP_MAIN_URL")}/news`}
          title={t("header.menu.news")}
        >
          {t("header.menu.news")}
        </a>
        <a
          href={`${envChangeType("REACT_APP_MAIN_URL")}/faq`}
          title={t("header.menu.faq")}
        >
          {t("header.menu.faq")}
        </a>
      </div>
    );
  };

  const handleClickAction = (key: string) => {
    switch (key) {
      case "info1":
        window.open(
          `${envChangeType("REACT_APP_MAIN_URL")}/news/detail/1`,
          "_blank"
        );
        break;
      case "info2":
        window.open(
          `${envChangeType("REACT_APP_MAIN_URL")}/news/detail/8`,
          "_blank"
        );
        break;
      case "info4":
        window.open(
          `${envChangeType("REACT_APP_MAIN_URL")}/news/detail/6`,
          "_blank"
        );
        break;
      case "info5":
        window.open(
          `${envChangeType("REACT_APP_MAIN_URL")}/news/detail/7`,
          "_blank"
        );
        break;
      case "about1":
        window.open(
          `${envChangeType("REACT_APP_MAIN_URL")}/news/detail/9`,
          "_blank"
        );
        break;
      case "about3":
        window.open(
          `${envChangeType("REACT_APP_MAIN_URL")}/news/detail/5`,
          "_blank"
        );
        break;
      default:
        break;
    }
  };

  const renderInfo = () => {
    return (
      <Col className={styles.menuColumn} span={getColSpan()}>
        <P2 className={styles.title} weight="medium" color="#404040">
          {t("footer.info.title")}
        </P2>
        <P2
          className={styles.link}
          color="#404040"
          onClick={() => handleClickAction("info1")}
        >
          {t("footer.info.1")}
        </P2>
        <P2
          className={styles.link}
          color="#404040"
          onClick={() => handleClickAction("info2")}
        >
          {t("footer.info.2")}
        </P2>
        {/* <P2
                className={styles.link}
                color="#404040"
                onClick={() => handleClickAction("info3")}
              >
                {t("footer.info.3")}
              </P2> */}
        <P2
          className={styles.link}
          color="#404040"
          onClick={() => handleClickAction("info4")}
        >
          {t("footer.info.4")}
        </P2>
        <P2
          className={styles.link}
          color="#404040"
          onClick={() => handleClickAction("info5")}
        >
          {t("footer.info.5")}
        </P2>
        {/* <P2
                className={styles.link}
                color="#404040"
                onClick={() => handleClickAction("info6")}
              >
                {t("footer.info.6")}
              </P2> */}
      </Col>
    );
  };

  const renderCompany = () => {
    return (
      <Col className={styles.menuColumn} span={getColSpan()}>
        <P2 className={styles.title} weight="medium" color="#404040">
          {t("footer.company.title", {
            name: process.env.REACT_APP_PROD_NAME_DISPLAY,
          })}
        </P2>
        <P2
          className={styles.link}
          color="#404040"
          onClick={() => handleClickAction("company1")}
        >
          {t("footer.company.1")}
        </P2>
        <P2
          className={styles.link}
          color="#404040"
          onClick={() => handleClickAction("company2")}
        >
          {t("footer.company.2")}
        </P2>
        <P2
          className={styles.link}
          color="#404040"
          onClick={() => handleClickAction("company3")}
        >
          {t("footer.company.3")}
        </P2>
      </Col>
    );
  };

  const renderAbout = () => {
    return (
      <Col className={styles.menuColumn} span={getColSpan()}>
        <P2 className={styles.title} weight="medium" color="#404040">
          {t("footer.about.title")}
        </P2>
        <P2
          className={styles.link}
          color="#404040"
          onClick={() => handleClickAction("about1")}
        >
          {t("footer.about.1")}
        </P2>
        {/* <P2
      className={styles.link}
      color="#404040"
      onClick={() => handleClickAction("about2")}
    >
      {t("footer.about.2")}
    </P2> */}
        <P2
          className={styles.link}
          color="#404040"
          onClick={() => handleClickAction("about3")}
        >
          {t("footer.about.3")}
        </P2>
      </Col>
    );
  };

  const renderContact = () => {
    return (
      <Col className={styles.menuColumn} span={getColSpan()}>
        <P2 className={styles.title} weight="medium" color="#404040">
          {t([
            `footer.contact.title.${process.env.REACT_APP_PROD_NAME_DEV}`,
            "footer.contact.title",
          ])}
        </P2>
        <P2 className={styles.link} color="#404040">
          {t([
            `footer.contact.1.${process.env.REACT_APP_PROD_NAME_DEV}`,
            "footer.contact.1",
          ])}
        </P2>
        <P2 className={styles.link} color="#404040">
          {t([
            `footer.contact.2.${process.env.REACT_APP_PROD_NAME_DEV}`,
            "footer.contact.2",
          ])}
        </P2>
        <P2 className={styles.link} color="#404040">
          {t([
            `footer.contact.3.${process.env.REACT_APP_PROD_NAME_DEV}`,
            "footer.contact.3",
          ])}
        </P2>
        <P2 className={styles.link} color="#404040">
          {t([
            `footer.contact.4.${process.env.REACT_APP_PROD_NAME_DEV}`,
            "footer.contact.4",
          ])}
        </P2>
      </Col>
    );
  };

  const renderContactSecond = () => {
    return (
      <Col className={styles.menuColumn} span={getColSpan()}>
        <P2 className={styles.title} weight="medium" color="#404040">
          {t([
            `footer.contact.second.title.${process.env.REACT_APP_PROD_NAME_DEV}`,
            "footer.contact.second.title",
          ])}
        </P2>
        <P2 className={styles.link} color="#404040">
          {t([
            `footer.contact.second.1.${process.env.REACT_APP_PROD_NAME_DEV}`,
            "footer.contact.second.1",
          ])}
        </P2>
        <P2 className={styles.link} color="#404040">
          {t([
            `footer.contact.second.2.${process.env.REACT_APP_PROD_NAME_DEV}`,
            "footer.contact.second.2",
          ])}
        </P2>
        <P2 className={styles.link} color="#404040">
          {t([
            `footer.contact.second.3.${process.env.REACT_APP_PROD_NAME_DEV}`,
            "footer.contact.second.3",
          ])}
        </P2>
        <P2 className={styles.link} color="#404040">
          {t([
            `footer.contact.second.4.${process.env.REACT_APP_PROD_NAME_DEV}`,
            "footer.contact.second.4",
          ])}
        </P2>
      </Col>
    );
  };

  return (
    <div
      className={`${styles.footerContainer} ${screens.sm ? "" : styles.mobile}`}
    >
      {renderHiddenLinks()}
      <div className={`${styles.footerColumn}`}>
        <div className={styles.colLeft}>
          <Image
            className={styles.logoImage}
            src={`/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/common/header_logo.png`}
            preview={false}
          />
          <div className={styles.socials}>
            {process.env.REACT_APP_PROD_NAME_DEV === "jstyleski" && (
              <div className={styles.imageContainer} onClick={handleClickLine}>
                <Image src={Line} width={52} height={52} preview={false} />
              </div>
            )}
            <P3
              style={{ textAlign: "left", minWidth: 150 }}
              color="rgba(64, 64, 64, 1)"
            >
              <Trans
                i18nKey={[
                  `footer.line.${process.env.REACT_APP_PROD_NAME_DEV}`,
                  "footer.line",
                ]}
              />
            </P3>
          </div>
        </div>
        <div className={styles.colRight}>
          <Row gutter={[0, 33]} className={styles.rightRow}>
            {process.env.REACT_APP_PROD_NAME_DEV === "jstyleski" &&
              renderInfo()}
            {/* {renderCompany()} */}
            {process.env.REACT_APP_PROD_NAME_DEV === "jstyleski" &&
              renderAbout()}
            {renderContact()}
            {process.env.REACT_APP_PROD_NAME_DEV === "jstyleski" &&
              renderContactSecond()}
          </Row>
        </div>
      </div>
      <div className={styles.copyright}>
        <P3 color="rgba(159, 159, 159, 1)">{`${t([
          `footer.copyright.${process.env.REACT_APP_PROD_NAME_DEV}`,
          "footer.copyright",
        ])}`}</P3>

        <div className={styles.copyrightLink}>
          <a href="https://www.17order.com/" target="_blank" rel="noreferrer">
            {t("footer.copyright.company")}
          </a>
          <P3 color="rgba(159, 159, 159, 1)">{` | v ${process.env.REACT_APP_VERSION}`}</P3>
        </div>
      </div>
    </div>
  );
};

export default FooterComponent;
